import React from 'react';

const AllEnquiryTransactions = () => {
  return (
    <div>
      <h1>AllEnquiryTransactions</h1>
    </div>
  );
};

export default AllEnquiryTransactions;
